module.exports = __webpack_public_path__ + "images/backend-error-msg-2e2ac17c.svg";